import { Controller } from "stimulus";

export default class extends Controller {
  static targets = ["form", "submitButton", "loadingModal"];

  connect() {
    console.log("PromptInput controller connected");

    // Initialize modals if elements exist
    const promptInputElement = document.getElementById("promptInput");
    const loadingModalElement = document.getElementById("loadingModal");

    if (promptInputElement) {
      this.promptModal = new bootstrap.Modal(promptInputElement);
    }

    if (loadingModalElement) {
      this.loadingModal = new bootstrap.Modal(loadingModalElement);
    }

    // Only add form listener if form target exists
    if (this.hasFormTarget) {
      this.formTarget.addEventListener("submit", (e) => e.preventDefault());
    }
  }

  submitForm(event) {
    event.preventDefault();
    event.stopPropagation();

    // If form is already being submitted, return
    if (this.isSubmitting) return;

    console.log("Submitting form...");

    // Set submitting flag
    this.isSubmitting = true;

    this.submitButtonTarget.setAttribute("disabled", "disabled");
    this.submitButtonTarget.style.pointerEvents = "none";
    this.submitButtonTarget.style.opacity = "0.5";

    // Hide prompt modal and show loading modal
    this.promptModal.hide();
    this.loadingModal.show();

    fetch(this.formTarget.action, {
      method: "POST",
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
        "X-CSRF-Token": document
          .querySelector('meta[name="csrf-token"]')
          .getAttribute("content"),
      },
      body: new URLSearchParams(new FormData(this.formTarget)),
    })
      .then((response) => response.json())
      .then((data) => {
        console.log("Response received: ", data);
        if (data.id) {
          this.checkImageStatus(data.id);
        } else {
          alert("An unexpected error occurred.");
          this.resetFormState();
        }
      })
      .catch((error) => {
        console.error("Error during form submission:", error);
        alert("An error occurred while processing your request.");
        this.resetFormState();
      });
  }

  checkImageStatus(imageId) {
    fetch(`/ai_image_ads/${imageId}/status`)
      .then((response) => response.json())
      .then((data) => {
        if (data.status === "completed") {
          window.location.reload();
        } else if (data.status === "failed") {
          alert(`Failed to generate image: ${data.error_message}`);
          this.resetFormState();
        } else {
          setTimeout(() => this.checkImageStatus(imageId), 2000);
        }
      })
      .catch((error) => {
        console.error("Error fetching image status:", error);
        alert("Failed to fetch image status.");
        this.resetFormState();
      });
  }

  resetFormState() {
    this.isSubmitting = false;
    this.submitButtonTarget.removeAttribute("disabled");
    this.submitButtonTarget.style.pointerEvents = "auto";
    this.submitButtonTarget.style.opacity = "1";
    this.loadingModal.hide();
    this.promptModal.show();
  }
}
